if (!customElements.get("accordion-element")) {
  customElements.define(
    "accordion-element",
    class AccordionElement extends HTMLElement {
      constructor() {
        super();
        this.buttonEl = this.querySelector("button[aria-expanded]");
        const controlsId = this.buttonEl.getAttribute("aria-controls");
        this.contentEl = this.querySelector(`#${controlsId}`);

        this.open = this.buttonEl.getAttribute("aria-expanded") === "true";
        this.buttonEl.addEventListener("click", this.onButtonClick.bind(this));
      }

      onButtonClick() {
        this.toggle(!this.open);
      }

      toggle(open) {
        if (open === this.open) {
          return;
        }

        if (open) {
          this.open = open;
          this.buttonEl.setAttribute("aria-expanded", `${open}`);
          this.contentEl.removeAttribute("hidden");
          setTimeout(() => (this.contentEl.style.height = this.querySelector("[data-content]").offsetHeight + "px"));
        } else {
          this.contentEl.style.height = "0px";
          this.open = open;
          this.buttonEl.setAttribute("aria-expanded", `${open}`);
          this.contentEl.addEventListener(
            "transitionend",
            () => {
              this.contentEl.removeAttribute("hidden", "");
            },
            { once: true }
          );
        }
      }

      open() {
        this.toggle(true);
      }

      close() {
        this.toggle(false);
      }
    }
  );
}
